import { type ReactElement } from 'react';
import { Link } from 'react-router-dom';
import NoIndex from '../components/NoIndex';

/**
 * Liste der Unterauftragsverarbeiter (Sub-Prozessoren) nach Art. 28 Abs. 2/4 DSGVO.
 *
 * Faktische Auflistung des tatsaechlichen Stacks. Bei Aenderung dieser Liste
 * (neuer Dienst, Wegfall) MUSS die AVV_VERSION (apps/api/src/lib/legal.ts)
 * hochgezaehlt werden, damit Kunden die neue Fassung erneut akzeptieren.
 *
 * HINWEIS: Grundgeruest – anwaltliche/DSB-Pruefung erforderlich. Insbesondere
 * ist fuer Google (Gemini) ein kostenpflichtiger Tier / Vertex AI mit Data
 * Processing Addendum (SCC) Voraussetzung, damit KEINE Trainingsnutzung erfolgt.
 */
const SUBPROCESSORS: { name: string; purpose: string; location: string; transfer: string }[] = [
  { name: 'Google Ireland Ltd. / Google LLC (Gemini API)', purpose: 'KI-gestützte Beleg- und Kontoauszugserkennung (OCR)', location: 'Irland / USA', transfer: 'EU-Standardvertragsklauseln (SCC) + Data Processing Addendum' },
  { name: 'Google Ireland Ltd. / Google LLC (Maps Distance Matrix)', purpose: 'Entfernungsberechnung für Reisekosten-Nachweise (Adressübermittlung)', location: 'Irland / USA', transfer: 'EU-Standardvertragsklauseln (SCC) + Data Processing Addendum' },
  { name: 'komoot GmbH (Photon / OpenStreetMap)', purpose: 'Adress-Autovervollständigung bei Nachweisen', location: 'Deutschland', transfer: 'kein Drittlandtransfer' },
  { name: 'Stripe Payments Europe Ltd.', purpose: 'Abwicklung der Abo-Zahlungen', location: 'Irland / USA', transfer: 'EU-Standardvertragsklauseln (SCC)' },
  { name: 'Hosting-Anbieter (Server in Deutschland)', purpose: 'Betrieb der Anwendung, Datenbank, Datei-Uploads', location: 'Deutschland', transfer: 'kein Drittlandtransfer' },
];

export default function Subprozessoren(): ReactElement {
  return (
    <div className="pt-24 pb-16 lg:pt-32 lg:pb-24">
      <NoIndex />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-secondary-900 mb-4">Unterauftragsverarbeiter</h1>
        <p className="text-secondary-700 leading-relaxed mb-6">
          Übersicht der von Saldify eingesetzten Unterauftragsverarbeiter (Sub-Prozessoren)
          im Rahmen des Auftragsverarbeitungsvertrags nach Art. 28 DSGVO. Über Änderungen
          dieser Liste informieren wir vorab; Sie haben ein Widerspruchsrecht.
        </p>

        <div className="overflow-x-auto rounded-xl border border-secondary-200">
          <table className="w-full text-left text-sm">
            <thead className="bg-secondary-50 text-secondary-900">
              <tr>
                <th className="px-4 py-3 font-semibold">Dienstleister</th>
                <th className="px-4 py-3 font-semibold">Zweck</th>
                <th className="px-4 py-3 font-semibold">Ort</th>
                <th className="px-4 py-3 font-semibold">Übermittlungsgrundlage</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-secondary-100 text-secondary-700">
              {SUBPROCESSORS.map((s) => (
                <tr key={s.name}>
                  <td className="px-4 py-3 font-medium text-secondary-900">{s.name}</td>
                  <td className="px-4 py-3">{s.purpose}</td>
                  <td className="px-4 py-3">{s.location}</td>
                  <td className="px-4 py-3">{s.transfer}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="mt-6 text-sm text-secondary-600">
          Hinweis: Auf der öffentlichen Website werden zudem <strong>Google Fonts</strong>
          (Google Ireland Ltd.) eingesetzt; dabei wird die IP-Adresse des Besuchers an Google
          übermittelt. Dies betrifft die Website-Nutzung, nicht die Verarbeitung Ihrer
          Auftragsdaten im eingeloggten Bereich – Einzelheiten in der{' '}
          <Link to="/datenschutz" className="text-primary-600 hover:underline">Datenschutzerklärung</Link>.
        </p>
        <p className="mt-4 text-xs text-secondary-500">
          Grundgerüst – ersetzt keine anwaltliche/datenschutzrechtliche Prüfung. Stand richtet
          sich nach der jeweils aktuellen AVV-Fassung.
        </p>
      </div>
    </div>
  );
}
